// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"b571a8b1","283":"e2b8742e","529":"9a9cbef4","552":"e94665e8"}[chunkId] + ".chunk.css";
};